import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'
import { DOCUMENTS_SOURCE_NAME_MAX_LENGTH } from 'const/limits'
import { SubmissionError } from 'redux-form'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import EditDocumentSourceForm from './EditDocumentSourceForm'

export class EditDocumentSource extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    leftSidebar: PropTypes.object.isRequired,

    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,

    requestChangeDocumentSourceName: PropTypes.func.isRequired
  }

  cancelForm = () => {
    this.props.leftSidebar.pop()
  }

  handleFormSubmit = ({ name }) => {
    const {
      intl,
      id,
      name: currentName,
      requestChangeDocumentSourceName
    } = this.props

    if (!name) {
      throw new SubmissionError({
        name: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_EMPTY' }),
        _error: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_EMPTY' })
      })
    } else if (name.length > DOCUMENTS_SOURCE_NAME_MAX_LENGTH) {
      const error = intl.formatMessage(
        { id: 'DOCUMENTS_SOURCES_NAME_TOO_LONG' },
        { limit: DOCUMENTS_SOURCE_NAME_MAX_LENGTH }
      )

      throw new SubmissionError({
        name: error,
        _error: error
      })
    }

    if (name !== currentName) {
      return new Promise((resolve, reject) => {
        requestChangeDocumentSourceName({
          id,
          name,
          resolve,
          reject
        })
      }).then(() => {
        this.cancelForm()
      }).catch(error => {
        if (error.code === 300) {
          throw new SubmissionError({
            name: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_DUPLICATE' }),
            _error: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_DUPLICATE' })
          })
        } else {
          throw error
        }
      })
    }
  }

  render () {
    const {
      id,
      name
    } = this.props

    return (
      <LeftSidebarView
        title={name}
      >
        <ViewBody>
          <EditDocumentSourceForm
            form={'editDocumentSource-' + id}
            initialValues={{
              name
            }}
            onSubmit={this.handleFormSubmit}
            onCancel={this.cancelForm}
          />
        </ViewBody>
      </LeftSidebarView>
    )
  }
}

export default injectIntl(withLeftSidebar(EditDocumentSource))

